import { useEffect, useState } from 'react';
import { getWindow } from './getWindow';

export const getIsMobile = () => {
    const navigator = getWindow()?.navigator;
    const userAgent = navigator?.userAgent || '';

    return {
        isMobile:
            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent) ||
            (/Mac/i.test(userAgent) && Boolean(navigator?.maxTouchPoints)),
        isIos: /iPad|iPhone|iPod/.test(userAgent),
    };
};

/**
 * Используется для определения мобильной версии приложения.
 * Если вернул null, значит мы еще на сервере
 */
export const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState<boolean | null>(null);

    useEffect(() => {
        setIsMobile(getIsMobile().isMobile);
    }, []);

    return isMobile;
};
